import React from 'react';
import { constitutions } from '../data/questionnaireData';
interface ResultsDisplayProps {
  results: Record<string, {
    score: number;
    status: string;
  }>;
  visible: boolean;
}
const ResultsDisplay: React.FC<ResultsDisplayProps> = ({
  results,
  visible
}) => {
  if (!visible) return null;
  return <div className="mt-8 p-6 bg-[#f8f9fa] rounded-xl border-2 border-[#2c5530]" data-id="element-57">
      <h2 className="text-2xl font-bold mb-4" data-id="element-58">
        🔍 Your TCM Constitution Results
      </h2>
      <div className="space-y-4" data-id="element-59">
        {Object.entries(results).map(([constitution, data]) => {
        const statusClass = data.status === 'Yes' || data.status === 'Basically Yes' ? 'bg-[#d4edda] border-l-4 border-[#28a745]' : data.status === 'Tend to' ? 'bg-[#fff3cd] border-l-4 border-[#ffc107]' : 'bg-[#f8d7da] border-l-4 border-[#dc3545]';
        const statusBadgeClass = data.status === 'Yes' || data.status === 'Basically Yes' ? 'bg-[#28a745] text-white' : data.status === 'Tend to' ? 'bg-[#ffc107] text-[#212529]' : 'bg-[#6c757d] text-white';
        return <div key={constitution} className={`p-4 rounded flex justify-between items-center ${statusClass}`} data-id="element-60">
              <div data-id="element-61">
                <div className="font-semibold text-[#2c5530]" data-id="element-62">
                  {constitution} Constitution
                </div>
                <div className="text-sm text-gray-600 mt-1" data-id="element-63">
                  {constitutions[constitution].description}
                </div>
              </div>
              <div className="text-right" data-id="element-64">
                <div className="font-bold text-lg" data-id="element-65">
                  {data.score.toFixed(1)}%
                </div>
                <div className={`px-3 py-1 rounded-full text-xs font-semibold uppercase ${statusBadgeClass}`} data-id="element-66">
                  {data.status}
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
};
export default ResultsDisplay;